import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import customTheme  from "./theme";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import { GoogleOAuthProvider } from "@react-oauth/google";
import SnackbarProvider from "./components/snackbar/snackbar-provider";
import { MotionLazy } from "./components/animate/motion-lazy";

const google_clientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <GoogleOAuthProvider clientId={google_clientID}>
    {/* <GoogleOAuthProvider clientId="1014560470948-5b594enc4782p3aiflmvl3i0kn29mqj9.apps.googleusercontent.com"> */}
      <ThemeProvider theme={customTheme }>
      <MotionLazy>
      <SnackbarProvider>
        <App />
        </SnackbarProvider>
        </MotionLazy>
      </ThemeProvider>
    </GoogleOAuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
